import { render } from "./DataCollectionUploadModal.vue?vue&type=template&id=bf72ea0e"
import script from "./DataCollectionUploadModal.vue?vue&type=script&lang=js"
export * from "./DataCollectionUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__